import React, { useEffect } from "react";

const FrfrUtilsCbUseEffect = (props) => {
  console.log('FrfrUtilsCbUseEffect');
  const {
    // componentDidMount, // TODO
    cb,
    dependencies,
  } = props;
  // const something_unchanged = null;
  let useEffect_dependencies_argument;
  if (Array.isArray(dependencies)) {
    useEffect_dependencies_argument = dependencies;
  }
  useEffect(() => {
    // auto cb
    if (typeof cb === 'function') {
      console.log('FrfrUtilsCbUseEffect WITH CALLBACK');
      cb();
    } else {
      console.log('FrfrUtilsCbUseEffect WITHOUT callback');
    }
  }, useEffect_dependencies_argument);
  return (<></>);
};

export default FrfrUtilsCbUseEffect;